import React from "react";
import { useNavigate } from "react-router-dom";
import { ThumbsUp, MessageCircle } from "lucide-react";
import { useBlogContext } from "../../../../BlogContext";
import { getBlogId } from "../../../../utils/blogUtils";

const fallbackURL =
  "https://media.istockphoto.com/id/2174551157/photo/cyber-security-data-protection-business-technology-privacy-concept.jpg?s=2048x2048&w=is&k=20&c=sCjAoM5vMvI7PXGFaTaOnRr1AppyOWmxPHkckruBq_A=";

const BlogList = () => {
  const { blogs, isLoading } = useBlogContext();
  const navigate = useNavigate();

  if (isLoading) return <p>Loading blogs...</p>;

  return (
    <div className="max-w-7xl mx-auto px-4 py-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12">
        {blogs.length > 0 ? (
          blogs.map((blog) => (
            <div
              key={getBlogId(blog)}
              className="bg-white rounded-2xl shadow hover:shadow-lg transition duration-300 overflow-hidden cursor-pointer flex flex-col h-full"
              onClick={() =>
                navigate(`/blogPage/blog/${getBlogId(blog)}`, { state: { blog } })
              }
            >
              <img
                src={blog.image_url || fallbackURL}
                alt="Blog"
                className="w-full h-48 object-cover"
              />

              <div className="p-4 flex flex-col h-full">
                <div className="flex justify-between items-center text-xs text-gray-500 mb-3">
                  <div className="flex items-center">
                    <img
                      src={`https://ui-avatars.com/api/?name=${blog.username}`}
                      alt={blog.username}
                      className="w-6 h-6 rounded-full mr-2"
                    />
                    <span className="text-sm text-black font-medium">
                      {blog.username}
                    </span>
                  </div>
                  <span>{new Date(blog.created_at).toLocaleDateString()}</span>
                </div>

                <div className="flex-1">
                  <h3 className="text-xl font-semibold mb-1">{blog.title}</h3>

                  {blog.subtitle && (
                    <p className="text-md italic text-gray-600 mb-2">
                      {blog.subtitle}
                    </p>
                  )}

                  <div
                    className="text-sm text-gray-600 mb-3 prose max-w-none"
                    dangerouslySetInnerHTML={{
                      __html:
                        blog.description.slice(0, 300) +
                        (blog.description.length > 300 ? "..." : ""),
                    }}
                  />

                  {blog.blog_tags && (
                    <div className="flex flex-wrap gap-2 mb-3">
                      {blog.blog_tags.split(",").map((tag, index) => (
                        <span
                          key={`${getBlogId(blog)}-${index}`}
                          className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full"
                        >
                          {tag.trim()}
                        </span>
                      ))}
                    </div>
                  )}
                </div>

                <div className="mt-auto pt-3 border-t border-gray-100">
                  <div className="flex items-center gap-4 text-gray-600">
                    <div className="flex items-center gap-1">
                      <ThumbsUp className="w-4 h-4" />
                      {blog.like_count || 0}
                    </div>
                    <div className="flex items-center gap-1">
                      <MessageCircle className="w-4 h-4" />
                      <p>{blog.comment_count || 0}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No blogs available. Please add some blogs.</p>
        )}
      </div>
    </div>
  );
};

export default BlogList;
